export const environment = {
  APP_ROOT: "https://guestlist.heartland.us/",
  SOCKET_HOST: "https://guestlist.heartland.us",
};



/** WEBPACK FOOTER **
 ** ./src/environments/environment.android.js
 **/